import { useTranslation } from "react-i18next";
import overrides from "../assets/translations/taskNameOverrides.json";

type TaskRef = {
    id?: number | string | null;
    name?: string | null;
} | null | undefined;

type LocalizedOverride = { en?: string };

const overrideEntries: Record<string, LocalizedOverride> = overrides.tasks as Record<string, LocalizedOverride>;

const lookupOverride = (
    languageCode: string,
    taskId: number | string | null | undefined
): string | undefined => {
    if (languageCode === "fr") return undefined;
    if (taskId === null || taskId === undefined) return undefined;

    const entry = overrideEntries[String(taskId)];
    return entry?.[languageCode as keyof LocalizedOverride];
};

export const useTranslatedTaskName = () => {
    const { i18n } = useTranslation();
    return (task: TaskRef): string => {
        const fallback = task?.name ?? "";
        return lookupOverride(i18n.language, task?.id) ?? fallback;
    };
};

export const translateTaskName = (
    languageCode: string,
    taskId: number | string | null | undefined,
    taskName: string | null | undefined
): string => {
    return lookupOverride(languageCode, taskId) ?? (taskName ?? "");
};
